import axios from '../util/request'
import qs from 'qs'
const md5 = require('js-md5')
const stamp = Date.now()

export const getGrainList = (data) => {
  data.stamp = stamp
  data.sign = md5(`${data.product_id}${stamp}${atob(localStorage.getItem('okey'))}`)
  return axios.get('/api/xiaosen/user/product/getColors', {
    params: { ...data }
  })
}

export const getColors = (data) => {
  data.stamp = stamp
  data.sign = md5(`${data.id}${stamp}${atob(localStorage.getItem('okey'))}`)
  return axios.get('/api/xiaosen/user/product/getColor', {
    params: {...data}
  })
}

export const getColor = (data) => {
  data.stamp = stamp
  data.sign = md5(`${data.product_id}${stamp}${atob(localStorage.getItem('okey'))}`)
  console.log(`${data.product_id}${stamp}${atob(localStorage.getItem('okey'))}`)
  return axios.get('/api/xiaosen/user/product/getColor', {
    params: {...data}
  })
}